<template>
  <div class="page-register">
    <div class="container">
      <div class="page-header">
        <h2>企业注册</h2>
      </div>
      <div class="page-body">
        <company ref="company" @verify="onVerify"></company>
        <user ref="user" @verify="onVerify"></user>
        <div class="mod-action">
          <div class="agreement">
            <a-checkbox v-model="agreement">
              我已阅读，理解并同意
              <a v-for="item in agreements" :key="item.title" target="_blank" :href="item.url">{{ item.title }}</a>
            </a-checkbox>
          </div>
          <a-button type="primary" size="large" :loading="loading" @click="onSubmit">立即注册</a-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { registerCompany } from '@/api/login'
import { verify } from '@/api/verify'
import Company from './components/company'
import User from './components/user'
import './index'

export default {
  data () {
    return {
      agreement: false,
      loading: false,
      agreements: []
    }
  },
  async created () {
    let userAppConfig = {}

    if (window.__MICRO_ROOT__) {
      const data = await window.__MICRO_ROOT__.cms.getPageData()

      if (data) {
        userAppConfig = data.config
      }
    }

    this.agreements = userAppConfig.agreements
  },
  methods: {
    onSubmit () {
      this.$refs.company.form.validateFields((errors, companyValues) => {
        if (!errors) {
          this.$refs.user.form.validateFields((errors, userValues) => {
            if (!errors) {
              const { token, finalToken, code, phone, email } = this.$refs.user

              if (!phone && !email) {
                this.$error({
                  content: '请输入联系方式！',
                  centered: true
                })
                return
              }

              if (!code) {
                this.$error({
                  content: `请输入${phone ? '手机' : '邮箱'}动态码！`,
                  centered: true
                })
                return
              }

              if (!token) {
                this.$error({
                  content: '请拖动滑块完成验证！',
                  centered: true
                })
                return
              }

              if (!finalToken) {
                this.$error({
                  content: '请点击获取动态码！',
                  centered: true
                })
                return
              }

              const { registerAgentInfo } = companyValues
              const { registerAgentUserInfo } = userValues

              if (!phone) {
                delete registerAgentUserInfo.phone
              }

              if (!email) {
                delete registerAgentUserInfo.email
              }

              delete registerAgentUserInfo.confirmPassword

              if (registerAgentInfo.country) {
                const cities = registerAgentInfo.country.slice()
                const len = cities.length

                registerAgentInfo.country = cities[0]

                if (len > 1) {
                  registerAgentInfo.province = cities[1]
                }

                if (len > 2) {
                  registerAgentInfo.city = cities[2]
                }
              }

              this.register({
                smsCode: code,
                token: finalToken,
                ...companyValues,
                ...userValues
              })
            }
          })
        }
      })
    },
    async register (params) {
      const { agreement } = this

      if (!agreement) {
        this.$error({
          content: '需要同意用户注册协议及隐私条款',
          centered: true
        })
        return
      }

      this.loading = true

      try {
        await registerCompany(params)

        this.$success({
          content: '注册成功',
          centered: true,
          onOk: () => {
            window.__MICRO_ROOT__?.router?.replace('/')
          }
        })
      } catch (err) {
        this.loading = false
        this.$error({
          content: err.message,
          centered: true
        })
        this.$refs.user.$refs.verify.refresh()
        if (err.code.toString().includes(1000)) {
          this.$refs.user.errCode = err.code
        }
      }
    },
    async onVerify (value, type, cb) {
      try {
        await verify({
          type,
          value
        })

        cb()
      } catch (err) {
        cb(err.message)
      }
    }
  },
  components: {
    Company,
    User
  }
}
</script>
